import React, { Component } from 'react'
import JqxGrid from '../../widgets/jqwidgets-react/react_jqxgrid';
import JqxMenu from '../../widgets/jqwidgets-react/react_jqxmenu';
import io from '../../utils/socket-client';
import {createGridResizer} from '../../utils/Sizer';
import locale from '../../GridLocale';

export default class GroupGrid extends Component {
    constructor(props){
        super(props);
        this.source = {
            localdata: props.groups,
            datatype: 'array',
            datafields: [
                { name: 'groupName', type: 'string' },
                { name: 'login', type: 'string' },
                { name: 'userName', type: 'string' },
            ]
        };
        this.dataAdapter = new window.$.jqx.dataAdapter(this.source);
        this.gridWidth = 620;
    }

    componentWillReceiveProps(nextProps){
        console.log('groupGrid update');
        this.source.localdata = nextProps.groups;
    }

    shouldComponentUpdate(nextProps, nextState){
        return false;
    }

    removeGroup(row){
        let rowid = this.refs.grid.getrowid(row);
        const {login, groupName} = this.source.localdata[row];
        io.sendChange({
            uri:io.GROUP_URI,
            operation: io.OPERATION_REMOVE,
            id: {
                login: login,
                groupName: groupName
            },
            success: () => {
                this.props.updateGroup(login, groupName);
                this.refs.grid.deleterow(rowid);
                this.source.localdata.splice(row, 1);
            }
        });
    }

    componentDidMount(){
        this.refs.grid.localizestrings(locale);
        createGridResizer(this, this.gridWidth);
        // window.$(window).resize(resizer);
        this.refs.grid.on('cellselect', (event) => {
            this.currentSelectedRow = event.args.rowindex;
        });
        this.refs.grid.on('cellunselect', () => {
            this.currentSelectedRow = null;
        });
        this.refs.grid.on('contextmenu', () => {
            return false;
        });
        this.refs.grid.on('rowclick', (event) => {
            this.currentSelectedRow = event.args.rowindex;
            if (event.args.rightclick) {
                this.refs.grid.selectrow(event.args.rowindex);
                let scrollTop = window.$(window).scrollTop();
                let scrollLeft = window.$(window).scrollLeft();
                let xCoords = (window.$(window).innerWidth() - parseInt(event.args.originalEvent.clientX, 10) > 100)
                    ? parseInt(event.args.originalEvent.clientX, 10) + 5 + scrollLeft
                    : parseInt(event.args.originalEvent.clientX, 10) - 95 + scrollLeft;
                let yCoords = (window.$(window).innerHeight() - parseInt(event.args.originalEvent.clientY, 10) > 87)
                    ? parseInt(event.args.originalEvent.clientY, 10) + 5 + scrollTop
                    : parseInt(event.args.originalEvent.clientY, 10) - 82 + scrollTop;
                this.refs.contextMenu.open(xCoords, yCoords);
                return false;
            }
        });

        this.refs.contextMenu.on('itemclick', (event) => {
            let args = event.args;
            let row = this.currentSelectedRow;
            this.refs.contextMenu.close();
            switch(window.$.trim(window.$(args).text())){
                case 'Добавить':
                    this.props.openNewGroupModal();
                    break;
                case 'Удалить':
                    setTimeout(() => {
                        if(window.confirm('Удалить?')) this.removeGroup(row);
                    }, 150);
                    break;
                default:
                    break;
            }
        });
    }

    render() {
        let columns = [
            { text: 'Имя группы', datafield: 'groupName', width: 200},
            { text: 'Расклейщик', datafield: 'login', width: 200},
            { text: 'Имя', datafield: 'userName', width: 200},
        ];

        return (
                <div ref={'container'} style={{display: 'flex', height: '100%', justifyContent: 'center', marginTop: 5, zIndex: -1, overflow: 'hidden'}}>
                    <JqxGrid
                        ref={'grid'}
                        height={window.$(window).innerHeight() - 45}
                        width={this.gridWidth}
                        editable={false}
                        columnsresize={true}
                        filterable={true}
                        enabletooltips={true}
                        showfilterrow={true}
                        source={this.dataAdapter}
                        columns={columns}
                        selectionmode={'singlecell'}/>
                    <JqxMenu ref='contextMenu'
                             width={100} height={87} mode={'popup'} autoOpenPopup={false}>
                        <ul>
                            <li>Добавить</li>
                            <li>Удалить</li>
                            <li>Закрыть</li>
                        </ul>
                    </JqxMenu>
                </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/GroupGrid.js